// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";

function TbLegendAugment(Props) {
  var legend = Props.legend;
  var augId = Props.augId;
  var onClick = Props.onClick;
  var t = Translation.useT(/* Augments */4);
  return React.createElement("div", {
              className: "flex flex-col items-center cursor-pointer px-2",
              onClick: onClick
            }, React.createElement("div", {
                  className: "relative w-[60px] h-[60px]"
                }, React.createElement("img", {
                      className: "border border-1-aa border-white2 rounded-full",
                      height: "44",
                      src: "https://cdn.tft.tools/sup9/legends/" + legend + ".png",
                      width: "44"
                    }), React.createElement(AugmentImage.make, {
                      className: "rounded-full absolute bottom-0 right-0",
                      augId: augId,
                      size: 44
                    })), React.createElement("div", {
                  className: "text-sm text-center"
                }, t(augId)));
}

function TbLegendAugment$Base(Props) {
  var legend = Props.legend;
  var augId = Props.augId;
  Translation.useT(/* Augments */4);
  return React.createElement("div", {
              className: "relative w-[58px] h-[58px]"
            }, React.createElement("img", {
                  className: "border border-1-aa border-white2 rounded-full",
                  height: "42",
                  src: "https://cdn.tft.tools/sup9/legends/" + legend + ".png",
                  width: "42"
                }), React.createElement(AugmentImage.make, {
                  className: "rounded-full absolute bottom-0 right-0",
                  augId: augId,
                  size: 42
                }));
}

var Base = {
  make: TbLegendAugment$Base
};

var make = TbLegendAugment;

export {
  make ,
  Base ,
  
}
/* react Not a pure module */
